module.exports = __webpack_public_path__ + "img/nutriteev-sem-slogan.95291ecb.svg";